export var DevicePlatformKind;
(function (DevicePlatformKind) {
    DevicePlatformKind["Mobile"] = "mobile";
    DevicePlatformKind["Tablet"] = "tablet";
    DevicePlatformKind["Desktop"] = "desktop";
})(DevicePlatformKind || (DevicePlatformKind = {}));
//# sourceMappingURL=DevicePlatformKind.js.map